<template>
  <div class="dataGoods">
    <div class="box">
      <!-- 头部 -->
      <div class="header_box">
        <div class="h_back" @click="$router.go(-1)">
          <span><i class="iconfont icon-shangchuanicon-fuben"></i></span>
          <!-- <span>返回</span> -->
        </div>
        <div class="title">
          <span @click="data_picker=''">库存变更记录</span>
        </div>
        <div class="data_picker" style="padding-left:0.2rem">
          <Calendar v-model="data_picker" @change="changeTime"></Calendar>
        </div>
      </div>
      <!-- 中间工具栏 -->
      <!-- <div class="tool_box">

      </div> -->
      <!-- 列表 -->
      <div class="list_table">
        <div class="table_header">
          <div class="table_tr">
            <div>商品名称</div>
            <div>包装形式</div>
            <div>操作动作</div>
            <div>操作前库存</div>
            <div>操作量</div>
            <div>操作后库存</div>
            <div>操作时间</div>
            <div>操作人</div>
          </div>
        </div>
        <div class="table_body">
          <md-scroll-view ref="dataGoodsScrollView" :scrolling-x="false" manual-init @end-reached="handleDataMore" :auto-reflow="true">
            <div class="table_tr" v-for="(item,index) in list" :key="index">
              <div class="mand-ellipsis">{{item.goods_name}}</div>
              <div class="mand-ellipsis">
                <div class="goods_item_type">
                  <span class="goods_item_type_1" v-if="item.goods_bale ==1">定装</span>
                  <span class="goods_item_type_2" v-if="item.goods_bale ==2">非定装</span>
                  <span class="goods_item_type_3" v-if="item.goods_bale ==3">散装</span>
                </div>
              </div>
              <div class="mand-ellipsis">{{operateList[item.operate-1]}}</div>
              <!-- 操作前 -->
              <div class="mand-ellipsis">
                <template v-if="item.goods_bale == 1">
                  <span>{{item.before_num-0}}{{unit_list[item.num_unit-1].name}}</span>
                </template>
                <template v-if="item.goods_bale == 2">
                  <span>{{item.before_num-0}}{{unit_list[item.num_unit-1].name}}</span>
                  (<span>{{item.before_weight-0}}公斤</span>)
                </template>
                <template v-if="item.goods_bale == 3">
                  <span>{{item.before_weight-0}}公斤</span>
                </template>
              </div>
              <!-- 操作量 -->
              <div class="mand-ellipsis">
                <template v-if="item.goods_bale == 1">
                  <span>{{item.amount_num-0}}{{unit_list[item.num_unit-1].name}}</span>
                </template>
                <template v-if="item.goods_bale == 2">
                  <span>{{item.amount_num-0}}{{unit_list[item.num_unit-1].name}}</span>
                  (<span>{{item.amount_weight-0}}公斤</span>)
                </template>
                <template v-if="item.goods_bale == 3">
                  <span>{{item.amount_weight-0}}公斤</span>
                </template>
              </div>
              <!-- 操作后 -->
              <div class="mand-ellipsis">
                <template v-if="item.goods_bale == 1">
                  <span>{{item.after_num-0}}{{unit_list[item.num_unit-1].name}}</span>
                </template>
                <template v-if="item.goods_bale == 2">
                  <span>{{item.after_num-0}}{{unit_list[item.num_unit-1].name}}</span>
                  (<span>{{item.after_weight-0}}公斤</span>)
                </template>
                <template v-if="item.goods_bale == 3">
                  <span>{{item.after_weight-0}}公斤</span>
                </template>
              </div>
              <div class="mand-ellipsis">{{item.create_time | toTime | toSlice}}</div>
              <div class="mand-ellipsis">{{item.realname}}</div>
            </div>
            <md-scroll-view-more :finished-text="list.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="isFinished" > </md-scroll-view-more>
          </md-scroll-view>
        </div>
      </div>  
    </div>
  </div>
</template>
<script>
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import { goodsBatch_data} from "@/api/work/stock";
import { isNumFloat,isPosFloat } from "@/utils/validate";
import Calendar from "@/components/Calendar"
export default {
  name: "dataGoods",
  components:{Calendar},
  filters:{
    toSlice(s){
      return s.substring(5,16)
    }
  },
  data() {
    return {
      show:false,
      type:"",
      isFinished:false,
      operateList:["盘点","报损","补货","退货","修改库存","报溢"],
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      data_picker:[],
      listQuery:{
        batch_id:'',
        page:1,
        pageSize:15,
        operate:'', //1盘点，2报损，3补货，4退货，5修改库存’
        keyword:'',
        from_time:'',
        to_time:'',
      },
      list:[],
    };
  },
  created() {
    this.listQuery.batch_id = this.$route.query.batch_id
    this.getList()
  },
  mounted() {
    
  },
  methods: {
    // 获取列表
    getList(){
      goodsBatch_data(this.listQuery).then(res=>{
        if(res.code == 200 ){
          if(this.listQuery.page == 1) this.list = []
          this.list = this.list.concat(res.data.list)
          if(this.list.length >= res.data.totalCount || res.data.list.length == 0){
              this.isFinished = true;
          }else{
              this.isFinished = false;
              this.listQuery.page++;
          }
          this.$refs.dataGoodsScrollView.init()
        }
      })
    },
    // time
    changeTime(){
      if(this.data_picker){
        this.listQuery.from_time = this.data_picker[0]
        this.listQuery.to_time = this.data_picker[1]
      }else{
        this.listQuery.from_time = ''
        this.listQuery.to_time = ''
      }
      this.listQuery.page = 1
      this.getList()
    },
    // 上拉加载更多数据
    handleDataMore() {
      if (this.isFinished) {
        return
      }
      this.$refs.dataGoodsScrollView.finishLoadMore()
      this.getList()
    },
  }
};
</script>
<style lang="less" scoped>
.dataGoods {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0.1rem 0.1rem 0;
  .box{
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 0.05rem 0.05rem 0 0;
    .header_box{
      height: 0.7rem;
      display: flex;
      padding: 0 0.2rem;
      align-items: center;
      justify-content: flex-start;
      box-shadow: 0 0.04rem 0.1rem 0.04rem #e1e1e1;
      .h_back{
        font-size: 0.24rem;
        span{
          margin-right: 0.1rem;
        }
        i{
          font-size: 0.24rem;
        }
      }
      .title{
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.7rem;
        padding-left: 0.2rem;
      }
    }
    .list_table{
      width: 100%;
      height: calc(100% - 0.7rem);
      padding: 0.1rem 0.1rem 0;
      .table_header{
        font-weight: bold;
        line-height: 0.6rem;
        
      }
      .table_body{
        height: calc(100% - 0.69rem);
      }
      .table_tr{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-bottom: 0.01rem solid #e5e5e5;
        line-height: 0.6rem;
        font-size: 0.20rem;
        &>div{
          padding: 0 0.05rem;
          width: 16%;
          text-align: center;
        }
      }
    }
  }
}
</style>